/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PATH_AUTH, ROOTS_AUTH} from '../../routing/paths'
import {ResetPassword} from './components/ResetPassword'

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}
        <a href="#" className="mb-12">
          <img alt="Logo" src={toAbsoluteUrl('/media/logos/Logo-WF_2.png')} className="h-50px h-sm-75px h-md-100px" />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <Switch>
            <Route path={PATH_AUTH.login} component={Login} />
            <Route path="/auth/registration" component={Registration} />
            <Route path={PATH_AUTH.forgotPassword} component={ForgotPassword} />
            <Route path={`${PATH_AUTH.resetPassword}/:slug/:email`} component={ResetPassword} />
            <Redirect from={ROOTS_AUTH} exact={true} to={PATH_AUTH.login} />
            <Redirect to={PATH_AUTH.login} />
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  )
}
